/* eslint-disable no-restricted-syntax */
import 'isomorphic-fetch';
import { clientId, clientSecret, appURL } from 'settings';

const { Raven } = window;

let APIHandler;
export default APIHandler = {
  makeRequest: (request, settings, customErrorHandler) =>
    fetch(request, settings)
      .then((response) => {
        if (response.ok) {
          return response
            .json()
            .then(json => json)
            .catch(() => false);
        }
        return { ok: false, response };
      })
      .catch((err) => {
        if (customErrorHandler) {
          console.log(err);
          // customErrorHandler(err);
        } else {
          // Raven.captureException('API call failed', {
          //   extra: { requestURL: request, requestSettings: settings, err },
          // });
        }
        return false;
      }),

  ok: (response) => {
    if (!response) {
      return false;
    }
    if (Object.keys(response).length > 0) {
      return true;
    }
    return false;
  },

  timeout(ms, promise) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('timeout'));
      }, ms);
      promise.then(resolve, reject);
    });
  },

  lastActive: (appId, email) => {
    const request = `https://crm.travpromobile.com/api/event?app_id=${appId}&email=${email}&action=open&category=last-active&name=app&value=session`;

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
    };

    const onError = (err) => {
      console.log('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(res => res);
  },

  getUserOld: (appId, email) => {
    const request = `https://accounts.travpromobile.com/api/v2/get_user/?email=${encodeURI(email)}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getUser: async (appId, accessToken) => {
    const request = `https://login.travpromobile.com/api/getUser/?app_id=${appId}`;

    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'GET',
      timeout: 5000,
    };

    const onError = (err) => {
      console.log('Error: ', err);
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      return err;
    };

    const res = await APIHandler.makeRequest(
      request,
      requestSettings,
      requestSettings,
      onError,
    );

    if (res.response && res.response.status !== 200) {
      console.log(res.response);
      return res;
    }
    return res;
  },

  checkPasswordUser: (email, password) => {
    const request = 'https://crm.travpromobile.com/api/authenticateMalibu';
    const data = {
      email,
      password,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(res => res);
  },

  setUser: (appId, params) => {
    // Format Date to dd-mm-yyyy, by adding a leading 0 and
    // slice last 2 characters to get Month and Day in two decimals.
    const date = new Date();
    const Month = `0${date.getMonth() + 1}`;
    const Day = `0${date.getDate()}`;
    const Year = date.getFullYear();
    const dateFormat = `${Year}-${Month.slice(-2)}-${Day.slice(-2)}`;

    let request = 'https://accounts.travpromobile.com/api/v2/user/?';
    request += `sales_companion_registered=${dateFormat}&`;
    request += `app_id=${appId}&`;
    request += 'type_of_user=pro';

    Object.keys(params).forEach((key) => {
      request += `&${key.replace(new RegExp('reg_', 'g'), '')}=${encodeURI(params[key])}`;
    });

    return APIHandler.makeRequest(request);
  },

  loginMagicLink: async (token) => {
    const request = 'https://login.travpromobile.com/oauth/token';
    const data = {
      grant_type: 'passwordless',
      client_id: clientId,
      client_secret: clientSecret,
      token,
    };
    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = err =>
      // alert("Currently it's very busy, please try again at a later moment. Thank you.");
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(request, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      return onError(await res.response.clone().json());
    }
    return res;
  },

  checkEmail(email) {
    const request = `https://login.travpromobile.com/api/user-exists?email=${email}&client_id=${clientId}`;
    return APIHandler.makeRequest(request, { method: 'POST' });
  },

  magicLink: async (email, language) => {
    const request = 'https://login.travpromobile.com/api/login/passwordless';

    const formData = new FormData();
    formData.append('email', email);
    formData.append('client_id', clientId);
    formData.append('url', appURL);
    formData.append('language', language);

    const requestSettings = {
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    const onError = err =>
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      err;
    const res = await APIHandler.makeRequest(
      request,
      requestSettings,
      requestSettings,
      onError,
    );
    return res;
  },

  checkPasswordUser: (email, password) => {
    const request = 'https://crm.travpromobile.com/api/authenticateMalibu';
    const data = {
      email,
      password,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(res => res);
  },

  updateUser: (appId, email, params) => {
    const parameters = params
      .map((p, i) => `${i > 0 ? '&' : ''}${p.param}=${p.val}`)
      .join('');
    const request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&${parameters}&app_id=${appId}`;
    return APIHandler.makeRequest(request, null, (err) => {
      Raven.captureException('Updating user failed', {
        extra: { requestURL: request, requestSettings: null, err },
      });
    });
  },

  updateRegisterUser: (appId, email, params) => {
    let request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&app_id=${appId}`;
    for (let i = 0; i < Object.keys(params).length; i += 1) {
      const objectName = Object.keys(params)[i];
      request += `&${objectName}=${encodeURI(params[objectName])}`;
    }
    return APIHandler.makeRequest(request);
  },

  buildSearchIndex: (appId) => {
    let request = `https://stack.travpromobile.com/buildindex.php?app_id=${appId}`;
    if (appId > 500) {
      request = `https://stack.travpromobile.com/buildindex_v2.php?app_id=${appId}`;
    }
    return APIHandler.makeRequest(request);
  },

  updateSearchIndex: (appId) => {
    const request = `https://search.travpromobile.com/updateindex_v2.php?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getSearchResults: (appId, query) => {
    const request = `https://stack.travpromobile.com/query_v2.php?app_id=${appId}&q=${encodeURIComponent(query)}`;
    return APIHandler.makeRequest(request);
  },

  setChapterCompleted: (appId, email, chapterId, chapterNumber) => {
    const request = 'https://crm.travpromobile.com/api/chapter';
    const data = {
      app_id: appId,
      email,
      chapter_id: chapterId,
      chapter_number: chapterNumber,
    };

    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      console.log(err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(res => res);
  },

  getBooths: (ids) => {
    let request =
      'https://travproconnect.com/api/v1/companies-filtered/?countrySort=true';
    ids.forEach((id) => {
      request += `&ids[]=${id}`;
    });
    return APIHandler.makeRequest(request);
  },

  getStands: (ids, lang) => {
    const request = `https://travproconnect.com/api/v1/companies-filtered?lang=${lang}&${ids}`;
    return APIHandler.makeRequest(request);
  },

  getUserProgress: (appId, email) => {
    let request = `https://progress.travpromobile.com/progress_user_v2/?email=${encodeURI(email)}`;
    if (['number', 'string'].includes(typeof appId)) {
      request += `&app_id=${appId}`;
    }
    if (typeof appId === 'object') {
      appId.forEach((id) => {
        request += `&app_id[]=${id}`;
      });
    }
    return APIHandler.makeRequest(request);
  },

  registerUserProgress: (email) => {
    const request = 'https://progress.travpromobile.com/users/';
    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      Raven.captureException('Registering user progress failed', {
        extra: { requestURL: request, requestSettings, err },
      });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => {
      if (res.status !== 422) {
        return res;
      }
      return false;
    });
  },

  loginUser: async (username, password) => {
    const request = 'https://login.travpromobile.com/oauth/token';
    const data = {
      grant_type: 'password',
      client_id: clientId,
      client_secret: clientSecret,
      username,
      password,
    };
    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log('Error: ', err);
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
      return err;
    };

    const res = await APIHandler.makeRequest(request, requestSettings, onError);

    if (res.response && res.response.status !== 200) {
      return onError(await res.response.clone().json());
    }
    return res;

    // return APIHandler.makeRequest(request, requestSettings, onError)
    //   .then(({ response }) => {
    //     const { status } = response;
    //     if (status !== 200) {
    //       return respone
    //         .then((stream) => {
    //           const res = new Response(stream);
    //           console.log({ res });
    //           return res;
    //         });
    //     }
    //     return response;
    //   });
  },

  registerSSOUser: (name, email, company, password, passwordConfirmation) => {
    const request = 'https://login.travpromobile.com/api/register';
    const data = {
      client_id: clientId,
      client_secret: clientSecret,
      name,
      email,
      company,
      password,
      password_confirmation: passwordConfirmation,
    };

    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(res => res);
  },

  forgotPassword: (email) => {
    const request = 'https://login.travpromobile.com/api/forgot_password';
    const data = {
      email,
      client_id: clientId,
    };

    const body = new URLSearchParams();

    for (const key in data) {
      if (key) body.set(key, data[key]);
    }

    const requestSettings = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      timeout: 5000,
      body,
    };

    const onError = (err) => {
      console.log('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(res => res);
  },

  resendVerificationLink(request) {
    const requestSettings = {
      method: 'GET',
      timeout: 5000,
    };

    const onError = (err) => {
      console.log('errorL ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(res => res);
  },

  getTravUser: (token) => {
    const request = 'https://progress.travpromobile.com/users/';
    const requestSettings = {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      Raven.captureException('Registering user progress failed', {
        extra: { requestURL: request, requestSettings, err },
      });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then((res) => {
      if (res.status !== 422) {
        return res;
      }
      return false;
    });
  },

  getFavoriteContent: (favorites) => {
    const request = 'https://cms.travpromobile.com/api/app/favorites/?';
    let params = '';

    favorites.forEach((item) => {
      if (item.type === 'p') {
        params += `page[]=${item.unid}&`;
      } else {
        params += `page[]=${item.type}${item.unid}&`;
      }
    });

    return APIHandler.makeRequest(`${request}${params}`);
  },

  getFavorite: (appId, email) => {
    const request = `https://progress.travpromobile.com/favorites_by_app/${appId}/?email=${email}`;
    return APIHandler.makeRequest(request);
  },

  addFavorite: (params) => {
    const request = 'https://progress.travpromobile.com/favorites/';
    return APIHandler.makeRequest(request, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  removeFavorite: (params) => {
    const request = 'https://progress.travpromobile.com/favorites';

    return APIHandler.makeRequest(request, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  setUserProgress: (params) => {
    const request = 'https://progress.travpromobile.com/progress';

    const requestObject = {
      chapter_id: params.chapterId,
      lastpage: params.lastPage,
      progress: params.progress,
      email: params.email,
    };

    const valid = Object.values(requestObject).every(param => param);
    const NaNCheck = +requestObject.lastpage && +requestObject.progress;
    const positive =
      +requestObject.lastpage >= 0 && +requestObject.progress >= 0;

    if (valid && NaNCheck && positive) {
      return APIHandler.makeRequest(request, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        timeout: 5000,
        body: JSON.stringify(requestObject),
      });
    }
    return new Promise(resolve =>
      resolve(new Error('One of the supplied values was invalid.')));
  },

  getLocation: () => {
    const request = 'https://pro.ip-api.com/json?key=lsCvt9AP5YqiVgL';
    return APIHandler.makeRequest(request);
  },

  getExhibitionStands: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsCategory: (id) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?id=${id}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsByCategory: (category, appId) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?category=${category}&app_id=${appId}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getExhibitionStandsUnsorted: (id) => {
    const request = `https://cms.travpromobile.com/api/app/exhibition?id=${id}&country=true`;
    return APIHandler.makeRequest(request);
  },

  getProfile: (profileId) => {
    const request = `https://travproconnect.com/api/v2/profile/${profileId}?format=json&chat=true`;
    return APIHandler.makeRequest(request);
  },

  getPremiumHotelsList: (lat1, lat2, lon1, lon2) => {
    const request = `https://travproconnect.com/api/v1/companies_region/?&live=true&appcode=vegas&lat1=${lat1}&lat2=${lat2}&lon1=${lon1}&lon2=${lon2}&preview=true`;
    return APIHandler.makeRequest(request);
  },

  getFreeHotelsList: (
    appId,
    lat1,
    lat2,
    lon1,
    lon2,
    query,
    destinations,
    hotelCategories,
    amenities,
  ) => {
    console.log('APIHandler received:', {
      destinations,
      hotelCategories,
      amenities,
    });

    // Build query parameters for the new filter structure
    let queryParams = `app=${appId}&lat1=${lat1}&lat2=${lat2}&lon1=${lon1}&lon2=${lon2}`;

    if (query) {
      queryParams += `&query=${encodeURIComponent(query)}`;
    }

    if (destinations && destinations.length > 0) {
      const destinationList = destinations.map(d => d.value || d).join(',');
      queryParams += `&destinations=${encodeURIComponent(destinationList)}`;
    }

    if (hotelCategories && hotelCategories.length > 0) {
      const categoryList = hotelCategories.map(c => c.value || c).join(',');
      queryParams += `&hotel_categories=${encodeURIComponent(categoryList)}`;
    }

    if (amenities && amenities.length > 0) {
      const amenityList = amenities.map(a => a.value || a).join(',');
      queryParams += `&amenities=${encodeURIComponent(amenityList)}`;
    }

    const request = `https://travpro.yourworldapps.nl/API/app/v2/listings.php?${queryParams}`;
    console.log('Final API request URL:', request);
    return APIHandler.makeRequest(request);
  },

  getNamedCollection: (title, appId) => {
    const request = `https://cms.travpromobile.com/api/app/named-collection?title=${title}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getMessage: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/message/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getAnnouncement: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/notification/true/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getUnreadMessages: (appId, lastChecked) => {
    const request = `https://cms.travpromobile.com/api/app/latest_message/?app_id=${appId}&date=${lastChecked}`;
    return APIHandler.makeRequest(request);
  },

  getChapters: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getChaptersAndProgress: (appId, email, locale) => {
    const request = `https://progressv2.travpromobile.com/progress/app/${appId}/sections?email=${encodeURI(email)}&locale=${locale}`;
    return APIHandler.makeRequest(request);
  },

  getFastFacts: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=fastfacts&format=json`;
    return APIHandler.makeRequest(request);
  },

  getToolbox: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=toolbox&format=json`;
    return APIHandler.makeRequest(request);
  },

  getContacts: (appId) => {
    const request = `https://cms.travpromobile.com/api/contact-us?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getTrainingPages: (chapterId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-content/?chapter_id=${chapterId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getDLC: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/getDLC/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getVideos: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-video/?app_id=${appId}&type=both&autoPlay=true&format=json&app=new&exclude=32020,32076,32018,32021`;
    return APIHandler.makeRequest(request);
  },

  getImages: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-photo?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getCollection: (itemID) => {
    const request = `https://cms.travpromobile.com/api/app/collection?sales_companion_item_id=${itemID}`;
    return APIHandler.makeRequest(request);
  },

  getDownloadURL: (file, name) => {
    let downloadURL = `https://stack.travpromobile.com/download.php?url=${file}`;
    if (name) {
      downloadURL += `&name=${name}`;
    }
    return downloadURL;
  },
  getAppInfo: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/app-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getSubApps: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/subApps/?format=json&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getContests: (appId, { currentDate, marketFilter = [] }) => {
    // const parameters = new URLSearchParams({ app_id: appId, current_date: currentDate });
    let date = new Date();
    [date] = date.toISOString().split('T');

    // TODO change app ID from pulling
    const parameters = new URLSearchParams({
      app_id: appId,
      current_date: date,
    });
    marketFilter.forEach(param =>
      parameters.append('market_filter[]', JSON.stringify(param)));
    // marketFilter.forEach((param) => parameters.append('market_filter[]', JSON.stringify({ id: 'GB' })));

    const request = [
      'https://cms.travpromobile.com/api/contests',
      parameters,
    ].join('?');

    return APIHandler.makeRequest(request);
  },

  getIncentive: (id) => {
    const request = `https://cms.travpromobile.com/api/incentive/?id=${id}`;
    return APIHandler.makeRequest(request);
  },

  getRewards(appId, accessToken, startDate = undefined, endDate = undefined) {
    const searchParams = {
      app_id: appId,
      start_date: startDate,
      end_date: endDate,
    };

    const filteredSearchParams = Object.fromEntries(Object.entries(searchParams).filter(([_, value]) => value !== undefined));

    const parameters = new URLSearchParams(filteredSearchParams);

    const request = [
      'https://crm.travpromobile.com/api/rewards',
      parameters,
    ].join('?');
    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };
    return APIHandler.makeRequest(request, requestSettings);
  },

  // New Points API (now contains badges)
  getUserPointsNew: (appId, email) => {
    const request = `https://crm.travpromobile.com/api/points/badges-overview?email=${email}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getUserRewards: async (email) => {
    const request = `https://accounts.travpromobile.com/api/v2/get_user/?email=${encodeURI(email)}`;
    return APIHandler.makeRequest(request);
  },

  trackEvent: (appId, email, category, name, value, label = null) => {
    const action = 'click';
    const request = 'https://crm.travpromobile.com/api/event';
    const data = {
      app_id: appId,
      email,
      action,
      category,
      name,
      value,
      label,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },

  addReward: (reward) => {
    const request = 'https://crm.travpromobile.com/api/reward';
    const data = {
      app_id: reward.appId,
      tour_operator_name: reward.tourOperator,
      client_last_name: reward.lastName,
      reservation_number: reward.reservationNumber,
      date_booked: reward.arrivalDate,
      arrival_date: reward.arrivalDate,
      departure_date: reward.departureDate,
      length_of_stay: reward.lengthOfStay,
      total_cost_usd: reward.totalCost,
      number_of_guests: reward.numberOfGuests,
      accommodation_name: reward.accommodationName,
      airline_name: reward.airline,
      origin_airport: reward.originAirport,
      destination_airport: reward.destinationAirport,
      url: reward.files,
      agent_email: reward.agentEmail,
      agent_last_name: reward.agentLastName,
      agent_first_name: reward.agentFirstName,
      client_first_name: '/',
      number_of_rooms: 0,
      wholesaler_name: reward.tourOperator,
      custom_1: reward.custom_1,
      custom_2: reward.custom_2,
      custom_3: reward.custom_3,
      custom_4: reward.custom_4,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      headers: {
        Accept: 'application/json',
      },
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(response => response);
  },

  trackSearch: (boothIds, email) => {
    const action = 'click';
    const request = `https://login.travpromobile.com/api/event?empty=${boothIds}`;
    const data = {
      app_id: 0,
      email,
      action: 'click',
      category: 'profile',
      name: 'search-result',
      value: 'search-result',
      unique: false,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },

  uploadFile: (file, accessToken) => {
    const request = 'https://crm.travpromobile.com/api/file-upload';
    const formData = new FormData();
    formData.append('name', file.name);
    formData.append('size', file.size);
    formData.append('type', file.type);
    formData.append('file', file.url);

    const requestSettings = {
      method: 'POST',
      timeout: 5000,
      body: formData,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    };

    return APIHandler.makeRequest(request, requestSettings).then(response => response);
  },

  /**
* Fetches the advisor dashboard payload for glass widgets (e.g. today's focus, milestones, rewards) from the CRM `GET
* /api/dashboard/todays-focus` endpoint.
*
* @param {string | number} appId Application ID; sent as `app_id` query parameter. Often a string (`REACT_APP_APP_ID`
*   / storage via `DataHandler.matchAppId`); may also be numeric in some call sites.
* @param {string} accessToken Bearer token for `Authorization`.
* @param {string} [langCode='en-US'] Locale sent as the `lang` query parameter. Default is `'en-US'`
* @returns {Promise<APIResponse>} The response from the API.
*/
  getAdvisorDashboardData: async (appId, accessToken, langCode = 'en-US') => {
    const request = new URL('https://crm.travpromobile.com/api/dashboard/todays-focus');
    request.searchParams.set('app_id', appId);
    request.searchParams.set('lang', langCode);

    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'GET',
      timeout: 5000,
    };

    const onError = (err) => {
      console.error('error: ', err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError);
  },

  setProfileImage: (accessToken, base64) => {
    const request = 'https://login.travpromobile.com/api/upload-profile';
    const data = {
      image: base64,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'POST',
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(res => res);
  },
};
